import React from "react";
import { createContext } from "react";

const GlobalDataContext = createContext({
  companySettings: {},
  setCompanySettings: () => {},
  visitorsNotCheckedOut: {},
  setVisitorsNotCheckedOut: () => {},
});

export default GlobalDataContext;
